<template>
  <div class="section__lk-content container-shadow fill-white" v-if="test">
    <modal-test-complete :test="test"/>
    <modal-test-result :test="test"/>
    <div class="test__header">
      <div class="test__header-course" v-if="test.courseTitle">
        {{test.courseTitle}}
      </div>
      <div class="test__header-title">
        {{test.title}}
      </div>
    </div>
    <div v-if="!test.review" class="test">
      <template v-if="test.status === 'in_started'">
        <test-start-info :test="test"/>
        <div class="row justify-content-start mt-64 test__footer-button">
          <div class="col-auto">
            <button @click="startTest()" :disabled="startLoading" class="btn btn-primary btn-with-icon">
              <b-spinner v-if="startLoading" />
              <span :class="{opacity: startLoading}">
                Начать тест
                <img class="icon left" src="/pic/icon-chevron-right.svg" />
              </span>
            </button>
          </div>
        </div>
      </template>
      <template v-else-if="test.status === 'active'">
        <test-start-progress :test="test" :answered-length="answeredLength" />
        <test-question-list v-model="cQueue" :test="test" :current-key="currentKey" />
        <div class="justify-content-between test__footer d-none d-lg-flex d-md-flex d-sm-flex">
          <div class="d-flex">
            <button @click="prev()" class="btn btn-primary btn-with-icon mr-24">
              <img class="icon rotate-180" src="/pic/icon-chevron-right.svg" />
              Предыдущий
            </button>
            <button @click="next()" class="btn btn-primary btn-with-icon">
              Следующий
              <img class="icon left" src="/pic/icon-chevron-right.svg" />
            </button>
          </div>
          <a href="javascript:void(0)" @click="showModal()" class="test__footer-link">
            Завершить тестирование
            <img src="/pic/icon-arrow-circle-right.svg" />
          </a>
        </div>
        <div class="d-block d-sm-none">
          <button @click="prev()" class="btn btn-primary btn-with-icon w-100">
            <img class="icon rotate-180" src="/pic/icon-chevron-right.svg" />
            Предыдущий
          </button>
          <button @click="next()" class="btn btn-primary btn-with-icon w-100 mt-2 mb-5">
            Следующий
            <img class="icon left" src="/pic/icon-chevron-right.svg" />
          </button>
          <a href="javascript:void(0)" @click="showModal()" class="test__footer-link w-100 d-block text-right">
            Завершить тестирование
            <img src="/pic/icon-arrow-circle-right.svg" />
          </a>
        </div>
      </template>
      <template v-else-if="test.status === 'solved' || (!canReview && test.status === 'finished')">
        <div class="test__info">
          <div class="mb-24 test__info-title-success">Тест завершен!</div>
          <div class="row d-flex flex-row">
            <div class="col-md flex-column">
              <div class="p-24 h-100 test__info-item">
                <img src="/pic/profile/icon-test-passed.svg" />
                <div class="mt-24">
                  Правильных ответов: {{ test.user_results.correct_count }}
                  <div class="test__info-item-text">
                    Вы правильно ответили на {{ test.user_results.correct_count }} из {{ test.questionsCount }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md flex-column" v-if="tryCount">
              <div class="p-24 h-100 test__info-item">
                <img src="/pic/profile/icon-test-retry.svg" />
                <div class="mt-24">
                  Осталось пересдач: {{ tryCount }}
                </div>
                <div class="test__info-item-text">
                  Вернитесь к тесту, чтобы пересдать его
                </div>
              </div>
            </div>
            <div v-if="canReview" class="col-md d-flex flex-column">
              <div class="p-24 h-100 test__info-item">
                <img src="/pic/profile/icon-test-review.svg" />
                <div class="mt-24">
                  Заполните отзыв
                </div>
                <div class="test__info-item-text">
                  Пожалуйста, оставьте отзыв о пройденном обучении. Нам важно Ваше мнение!
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row d-flex justify-content-between test__footer border-0 align-items-center test-footer">
          <div v-if="canReview" class="d-flex test-footer__buttons">
            <button @click="toReview()" class="btn btn-primary btn-with-icon mr-2">
              Перейти к отзыву
              <img class="icon left" src="/pic/icon-chevron-right.svg" />
            </button>
            <button @click="restart()" class="btn btn-outline-primary btn-with-icon" v-if="tryCount">
              <span class="icon">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.66732 11.6666H2.66732V4.33329H7.86732L7.33398 4.85996C7.20845 4.98461 7.13757 5.15403 7.13695 5.33093C7.13632 5.50784 7.206 5.67776 7.33065 5.80329C7.4553 5.92883 7.62472 5.9997 7.80163 6.00033C7.97854 6.00095 8.14845 5.93128 8.27398 5.80663L9.94065 4.13996C10.0031 4.07798 10.0527 4.00425 10.0866 3.92301C10.1204 3.84177 10.1379 3.75463 10.1379 3.66663C10.1379 3.57862 10.1204 3.49148 10.0866 3.41024C10.0527 3.329 10.0031 3.25527 9.94065 3.19329L8.27398 1.52663C8.14908 1.40246 7.98011 1.33276 7.80398 1.33276C7.62786 1.33276 7.45889 1.40246 7.33398 1.52663C7.2715 1.5886 7.2219 1.66233 7.18806 1.74357C7.15421 1.82481 7.13679 1.91195 7.13679 1.99996C7.13679 2.08797 7.15421 2.1751 7.18806 2.25634C7.2219 2.33758 7.2715 2.41132 7.33398 2.47329L7.86065 2.99996H2.00065C1.82384 2.99996 1.65427 3.0702 1.52925 3.19522C1.40422 3.32025 1.33398 3.48981 1.33398 3.66663V12.3333C1.33398 12.5101 1.40422 12.6797 1.52925 12.8047C1.65427 12.9297 1.82384 13 2.00065 13H3.66732C3.84413 13 4.0137 12.9297 4.13872 12.8047C4.26375 12.6797 4.33398 12.5101 4.33398 12.3333C4.33398 12.1565 4.26375 11.9869 4.13872 11.8619C4.0137 11.7369 3.84413 11.6666 3.66732 11.6666ZM14.0007 2.99996H12.334C12.1572 2.99996 11.9876 3.0702 11.8626 3.19522C11.7376 3.32025 11.6673 3.48981 11.6673 3.66663C11.6673 3.84344 11.7376 4.01301 11.8626 4.13803C11.9876 4.26305 12.1572 4.33329 12.334 4.33329H13.334V11.6666H7.75398L8.28065 11.14C8.34314 11.078 8.39273 11.0042 8.42658 10.923C8.46042 10.8418 8.47785 10.7546 8.47785 10.6666C8.47785 10.5786 8.46042 10.4915 8.42658 10.4102C8.39273 10.329 8.34314 10.2553 8.28065 10.1933C8.15574 10.0691 7.98678 9.99943 7.81065 9.99943C7.63453 9.99943 7.46556 10.0691 7.34065 10.1933L5.67398 11.86C5.6115 11.9219 5.5619 11.9957 5.52806 12.0769C5.49421 12.1581 5.47679 12.2453 5.47679 12.3333C5.47679 12.4213 5.49421 12.5084 5.52806 12.5897C5.5619 12.6709 5.6115 12.7446 5.67398 12.8066L7.34065 14.4733C7.46619 14.5979 7.6361 14.6676 7.81301 14.667C7.98992 14.6664 8.15933 14.5955 8.28398 14.47C8.40864 14.3444 8.47831 14.1745 8.47769 13.9976C8.47706 13.8207 8.40619 13.6513 8.28065 13.5266L7.75398 13H14.0007C14.1775 13 14.347 12.9297 14.4721 12.8047C14.5971 12.6797 14.6673 12.5101 14.6673 12.3333V3.66663C14.6673 3.48981 14.5971 3.32025 14.4721 3.19522C14.347 3.0702 14.1775 2.99996 14.0007 2.99996Z"/>
                </svg>
              </span>
              Пересдать тест
            </button>
          </div>
          <div v-else-if="test.type === 'simple_recommend'" class="test-footer__return">
            <router-link to="/lk/recommend" class="test__footer-link">
              <img style="transform: rotate(180deg);" src="/pic/icon-arrow-circle-right.svg" />
              Вернуться в систему подбора
            </router-link>
          </div>
          <div class="test-footer__return">
            <router-link to="/lk" class="test__footer-link">
              Вернуться в личный кабинет
              <img src="/pic/icon-arrow-circle-right.svg" />
            </router-link>
          </div>
        </div>
      </template>
      <template v-else-if="canReview && test.status === 'finished'">
        <review-test />
      </template>
    </div>
    <template v-else>
      <template v-if="cQueue">
        <div class="text-success mb-48">Вы правильно ответили на {{ test.user_results.correct_count }} из {{test.questionsCount}} {{ test.questionsCount | pluralize('ru', ['вопроса', 'вопросов', 'вопросов']) }} </div>
        <test-question-list class="mb-5" v-model="cQueue" :test="test" :current-key="currentKey" />
      </template>
      <template v-else>
        <div class="text-center">
          <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M88.32 52.74L62.58 78.54L52.68 68.64C52.1421 68.0119 51.4802 67.5018 50.7358 67.1416C49.9915 66.7815 49.1807 66.5791 48.3544 66.5472C47.528 66.5153 46.704 66.6545 45.9341 66.9562C45.1641 67.2578 44.4649 67.7154 43.8801 68.3001C43.2954 68.8848 42.8379 69.5841 42.5362 70.3541C42.2346 71.124 42.0953 71.948 42.1272 72.7743C42.1592 73.6006 42.3615 74.4114 42.7217 75.1558C43.0818 75.9002 43.5919 76.5621 44.22 77.1L58.32 91.26C58.8807 91.8161 59.5456 92.256 60.2766 92.5546C61.0076 92.8532 61.7904 93.0046 62.58 93C64.1541 92.9934 65.6625 92.3685 66.78 91.26L96.78 61.26C97.3424 60.7022 97.7888 60.0386 98.0934 59.3075C98.398 58.5763 98.5548 57.7921 98.5548 57C98.5548 56.2079 98.398 55.4237 98.0934 54.6925C97.7888 53.9614 97.3424 53.2978 96.78 52.74C95.6559 51.6225 94.1351 50.9952 92.55 50.9952C90.9649 50.9952 89.4442 51.6225 88.32 52.74ZM72 12C60.1332 12 48.5328 15.5189 38.6658 22.1118C28.7989 28.7047 21.1085 38.0754 16.5673 49.039C12.026 60.0026 10.8378 72.0666 13.1529 83.7054C15.468 95.3443 21.1825 106.035 29.5736 114.426C37.9648 122.818 48.6558 128.532 60.2946 130.847C71.9335 133.162 83.9975 131.974 94.961 127.433C105.925 122.892 115.295 115.201 121.888 105.334C128.481 95.4673 132 83.8669 132 72C132 64.1207 130.448 56.3185 127.433 49.039C124.418 41.7595 119.998 35.1451 114.426 29.5736C108.855 24.0021 102.241 19.5825 94.961 16.5672C87.6815 13.5519 79.8793 12 72 12ZM72 120C62.5065 120 53.2262 117.185 45.3327 111.911C37.4391 106.636 31.2868 99.1397 27.6538 90.3688C24.0208 81.5979 23.0702 71.9468 24.9223 62.6357C26.7744 53.3246 31.346 44.7718 38.0589 38.0589C44.7718 31.346 53.3246 26.7744 62.6357 24.9223C71.9468 23.0702 81.598 24.0208 90.3688 27.6538C99.1397 31.2868 106.636 37.4391 111.911 45.3326C117.185 53.2262 120 62.5065 120 72C120 84.7304 114.943 96.9394 105.941 105.941C96.9394 114.943 84.7304 120 72 120Z" fill="#BDBDBD"/>
          </svg>
          <h3 class="mt-2">Тест успешно завершен</h3>
          <div class="text-success mb-48">Вы правильно ответили на {{ test.user_results.correct_count }} из {{test.questionsCount}} {{ test.questionsCount | pluralize('ru', ['вопроса', 'вопросов', 'вопросов']) }} </div>
          <router-link to="/lk" class="test__footer-link">
            Вернуться в личный кабинет
            <img src="/pic/icon-arrow-circle-right.svg" />
          </router-link>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import {eventBus} from "@/main";
import ApiService from "../../../services/api.service";
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import TestStartInfo from "@/components/profile/test/TestStartInfo.vue";
import ModalTestComplete from "@/components/modal/ModalTestComplete.vue";
Vue.use(BootstrapVue)
import $ from "jquery";
import ReviewTest from "@/components/ReviewTest.vue";
import ModalTestResult from "@/components/modal/ModalTestResult.vue";
import TestStartProgress from "@/components/profile/test/TestStartProgress.vue";
import TestQuestionList from "@/components/profile/test/TestQuestionList.vue";

export default {
  name: "Test",
  components: {
    TestQuestionList,
    TestStartProgress, ModalTestResult, ReviewTest, ModalTestComplete, TestStartInfo},
  data() {
    return {
      test: null,
      startLoading: false,
      startLoadingSend: false,
      currentKey: 0,
      cQueue: null,
      hasTest: false,
      testId: null,
      answeredLength: 0
    }
  },
  mounted() {
    $('.modal-backdrop').remove();
    eventBus.$on('test:send', () => {
      this.sendQueue(true)
    })
    eventBus.$on('test:result', async () => {
      let res = await ApiService.postJson('tests/' + this.testId + '/results', {})
      this.test = res.data
    })
    eventBus.$on('review:send', async () => {
      await this.loadTest()
    })
    eventBus.$on('test:retry', async() => {
      return this.restart()
    })
    eventBus.$on('test:sendQueue', async () => {
      this.sendQueue()
    })
    eventBus.$on('test:setCurrentKey', (key) => {
      this.currentKey = key
    })
    this.loadTest()
  },
  methods: {
    loadTest() {
      this.testId = this.$route.params.id
      ApiService.get('tests/' + this.testId).then(res => {
        this.test = res.data
        if(this.test.status === 'finished' || this.test.status === 'solved') {
          eventBus.$emit('test:solved')
          eventBus.$emit('test:finish')
        }
        this.cQueue = this.prepareTest.cQueue
        this.answeredLength = this.prepareTest.answeredLength
        if(window.location.hash === '#test') {
          this.gotoTest()
        } else {
          this.goto()
        }
        if(this.$route.query.start) {
          this.startTest()
        }
      })
    },
    toReview() {
      if(this.tryCount && this.test.isShowResult) {
        $('#test-result').modal('show')
      } else {
        eventBus.$emit('test:result')
      }
    },
    showModal() {
      $('#test-complete').modal('show')
    },
    next() {
      this.currentKey = this.currentKey + 1
      if(this.currentKey > (this.test.questionsCount-1)) {
        this.currentKey = 0;
      }
    },
    prev() {
      this.currentKey = this.currentKey - 1
      if(this.currentKey < 0) {
        this.currentKey = this.test.questionsCount-1;
      }
    },
    startTest() {
      if(this.test.status !== 'solved' && this.test.status !== 'finished') {
        this.start()
      }
    },
    restart() {
      if(this.test.status !== 'finished' && this.tryCount) {
        this.start()
      }
    },
    async start() {
      this.startLoading = true
      let res = await ApiService.post('tests/' + this.testId + '/starts', {}, false)
      if(res.status >= 200 && res.status < 208) {
        this.test = res.data
        this.cQueue = this.prepareTest.cQueue
        this.answeredLength = this.prepareTest.answeredLength
      }
      this.startLoading = false
    },
    goto() {
      window.scrollTo(0, 0);
    },
    gotoTest() {
      this.hasTest = true
      const ele = document.getElementById('trainingTest')
      console.log(ele.getBoundingClientRect())
      window.scrollTo(0, ele.getBoundingClientRect().y);
    },
    unJoin(answer) {
      let ret = false;
      if(typeof answer === 'string') {
        answer = answer.split(',');
        ret = {};
        answer.forEach((val) => {
          ret[val] = true;
        });
      }
      return ret;
    },
    arrayKeys(array) {
      let keys = [];
      for (const [val, key] of Object.entries(array)) {
        if(key) {
          keys.push(val);
        }
      }
      return keys;
    },
    sendQueue(finish = false) {
      if(this.isFinished) {
        return;
      }
      let queue = [],
          length = 0;
      for (const [question, value] of Object.entries(this.cQueue)) {
        if(value.answer) {
          const answer = JSON.parse(JSON.stringify(value.answer));
          queue.push({
            question:  question,
            answer: typeof answer === 'object'
                ? this.arrayKeys(answer).join()
                : answer,
            answer_id: typeof answer === 'number'
                ? answer : null,
          })
          length++;
        }
      }
      if(!length) {
        return;
      }

      if (finish) {
        this.startLoading = true
        ApiService.post('tests/' + this.test.id + '/finishes', {queue: queue }).then((res) => {
          this.test = res.data;
          this.startLoading = false
          eventBus.$emit('test:solved')
          eventBus.$emit('test:finish')
        });
      } else {
        ApiService.post('tests/' + this.test.id, {queue: queue }).then((res) => {
          this.answeredLength = length;
          if(res.status === 208) {
            this.startLoading = true
            ApiService.post('tests/' + this.test.id + '/finishes', {queue: queue }).then((res) => {
              this.test = res.data;
              this.startLoading = false
            });
          }
          if (res.data.timer) {
            this.test.timer = res.data.timer;
          }
        })
      }
    }
  },
  computed: {
    canReview() {
      return this.test.type !== 'simple_recommend' && this.test.type !== 'simple';
    },
    isFinished() {
      return this.test.status === 'finished'
    },
    questionsCount() {
      return this.test.questionsCount ? this.test.questionsCount : (this.test.questions_count ? this.test.questions_count : 0);
    },
    tryCount() {
      return this.test.retakes - this.test.user_results.retakes;
    },
    prepareTest() {
      const questions = this.test.questions
      let cQueue = {},
          length = 0;

      if(!questions || !questions.length) {
        return {
          queue: [],
          answeredLength: 0
        }
      }

      // Установка объектов ответа на вопросы
      questions.forEach((question) => {
        if(question.user) {
          if(question.multiple) {
            cQueue[question.id] = {
              answer: this.unJoin(question.user.answer)
            }
          } else if(question.typed) {
            cQueue[question.id] = {
              answer: question.user.answer
            }
          } else {
            cQueue[question.id] = {
              answer: question.user.answer_id
            }
          }
          length++;
        } else {
          if(question.multiple) {
            cQueue[question.id] = {
              answer: {}
            };
          } else {
            cQueue[question.id] = {};
          }
        }
      })
      return {
        cQueue: cQueue,
        answeredLength: length
      }
    }
  }
}
</script>
<style lang="scss">
@media (max-width: 768px) {
  .test-footer {
    display: block!important;
    &__return {
      text-align: center;
      width: 100%;
      margin-top: 20px;
    }
    &__buttons {
      justify-content: space-between;
      padding: 0 15px;
    }
  }
}
</style>